/* eslint-disable @typescript-eslint/no-explicit-any */
import { Route as ReactDOMRoute, Redirect } from 'react-router-dom'

import { IRouteProps } from '../../@types/application/RouteApplication.types'
import { useAuth } from '../../modules/auth/hooks/auth'

function Route({
  isPrivate = false,
  component: Component,
  scope,
  ...rest
}: IRouteProps): any {
  const { user, perfil } = useAuth()
  const isLogged = !!user
  let redirect404 = false

  if (isLogged && scope) {
    redirect404 = !scope.includes(perfil)
  }

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!user ? (
          redirect404 ? (
            <Redirect to={{ pathname: '/404' }} />
          ) : (
            Component && <Component />
          )
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/lotes',
              state: { from: location },
            }}
          />
        )
      }}
    />
  )
}

export default Route
